module.exports = __webpack_public_path__ + "static/media/142.62c7be42.webp";